$('.dropdown').dropdown({
    placeholder: false
});
$('.ui.accordion').accordion();
$('.menu .item').tab();
$('.tooltip').popup();